import styled from 'styled-components'

export const PrepaymentMsg = styled.p`
  color: ${({ theme }) => theme.colors.veryDarkGray};
  font-size: ${({ theme }) => theme.fonts._14};
  font-weight: ${({ theme }) => theme.fonts.regularWeight};
  line-height: 24px;
  margin-bottom: 40px;
`
